import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommentService {
  
  private data = new BehaviorSubject<commentModel>({ isCommentReq: false, questionId: '' });

  // castValue notify Comment feature, once it receve new value.
  castValue = this.data.asObservable();
  
  /**
  * Store a value (Boolean or Array) in data observable
  * @param newValue type boolean or Array
  * For Radio: comment require = true, comment not require = false
  * For Checkbox: if array lenght > 0, then comment is not require
  * Work for radio & checkbox
  */
  //  
  sendValue(isCommentReq:boolean, parentId:string, inputType?:string) {
    this.data.next({ isCommentReq: isCommentReq, questionId: parentId, inputType: inputType });
  }
}

type commentModel = {
  isCommentReq: boolean;
  questionId: string;
  inputType?: string
};